import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

export type OverdueFilterValue = 'all' | 'historical' | 'fresh';

const OPTIONS: { value: OverdueFilterValue; label: string }[] = [
    { value: 'all', label: 'Все' },
    { value: 'historical', label: 'Исторические' },
    { value: 'fresh', label: 'Только свежие' },
];

export interface OverdueFilterProps {
    value?: OverdueFilterValue;
    onChange: (value: OverdueFilterValue) => void;
}

export default function OverdueFilter({ value = 'all', onChange }: OverdueFilterProps) {
    const handleChange = (e: SelectChangeEvent) => onChange(e.target.value as OverdueFilterValue);

    return (
        <Select value={value} onChange={handleChange} fullWidth size="small">
            {OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                </MenuItem>
            ))}
        </Select>
    );
}
